import retry from 'async-retry';
import { isNotNil, pickBy } from 'es-toolkit';
import { attemptAsync } from 'es-toolkit/util';
import { rejectAfter, wait } from '../promises';
import { HTTPError, TimeoutError } from './errors';
import { getRetryAfterMs, transformOptions } from './utils';
const defaultRetryOptions = { retries: 2 };
export function fetchWithRetry(resource, options) {
    const { retries = defaultRetryOptions.retries, factor, minTimeout, maxTimeout, randomize, onRetry, parseAs = 'json', post, timeout, ...fetchOptions } = options || {};
    const retryOptions = {
        retries,
        factor,
        minTimeout,
        maxTimeout,
        randomize,
        onRetry,
    };
    async function retrier(bail) {
        let res;
        const fetchPromise = fetch(resource, transformOptions(fetchOptions, post));
        if (!timeout) {
            res = await fetchPromise;
        }
        else {
            try {
                res = (await rejectAfter(fetchPromise, timeout));
            }
            catch (error) {
                if (error === 'TIMED_OUT') {
                    return bail(new TimeoutError());
                }
                throw error;
            }
        }
        const [bodyParseError, parsedBody] = await attemptAsync(() => parseAs ? res[parseAs]?.() : Promise.resolve(null));
        if (res.ok) {
            if (bodyParseError) {
                throw bodyParseError;
            }
            return parseAs && parsedBody !== null ? parsedBody : res;
        }
        if (res.status === 401) {
            return bail(new HTTPError(res, parsedBody));
        }
        if (res.status === 429) {
            const retryAfterMs = getRetryAfterMs(res.headers);
            if (retryAfterMs) {
                await wait(Math.max(retryAfterMs - (minTimeout ?? 1000), 0));
                throw new HTTPError(res, parsedBody);
            }
        }
        if (res.status < 500) {
            return bail(new HTTPError(res, parsedBody));
        }
        throw new HTTPError(res, parsedBody);
    }
    return retry(retrier, pickBy(retryOptions, isNotNil));
}
